(function (d, w) {
  var articleContent = d.querySelector(".template-article-content");
  if (!articleContent) return;

  var allH2 = articleContent.querySelectorAll("h2");
  if (!allH2 || allH2.length === 0) {
    var articleTOCElement = document.querySelector(".article-header-row-toc");
    if (articleTOCElement) {
      articleTOCElement.remove();
    }

    var stickyTOCElement = document.querySelector(".sticky-article-toc");
    if (stickyTOCElement) {
      stickyTOCElement.remove();
    }

    return;
  }
  var H2Count = allH2.length;
  var extraScrollSpacing = 200;

  // Stable ids so a section can be linked (#hvad-er-hyaluronsyre).
  var usedIds = {};
  allH2.forEach((h2) => {
    if (h2.id) return;
    var base = h2.textContent.trim().toLowerCase()
      .replace(/æ/g, "ae").replace(/ø/g, "oe").replace(/å/g, "aa")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "afsnit";
    var id = base, n = 2;
    while (usedIds[id] || d.getElementById(id)) id = base + "-" + n++;
    usedIds[id] = true;
    h2.id = id;
  });

  // The sticky bar overlays the page and only shows once the reader reaches the first section.
  var stickyBar = d.querySelector(".sticky-article-toc");
  if (stickyBar) {
    stickyBar.classList.add("sticky-article-toc--deferred");
    stickyBar.style.marginBottom = -stickyBar.offsetHeight + "px";
  }

  const scrollToElement = (ele) => {
    var scrollY = Math.ceil(
      ele.getBoundingClientRect().y + w.scrollY - extraScrollSpacing
    );

    w.scrollTo({
      top: scrollY,
      behaviour: "smooth",
    });

    setTimeout(() => {
      scrollCallback();
    }, 350);
  };

  var stickyButtons = [];

  const renderTOC = () => {
    var template = d.querySelector("#Article-toc-content");
    var placeholder = d.querySelector("[data-toc-placeholder]");
    if (!template || !placeholder) return;

    var H2Threshold = 4;
    var aboveThreshold = H2Count > H2Threshold;
    var bodyQueryString = "[data-toc-below-threshold]";

    if (aboveThreshold) {
      bodyQueryString = "[data-toc-above-threshold]";
    }

    var TOCContainer = template.content
      .querySelector(bodyQueryString)
      .cloneNode(true);
    var TOCContentBody =
      TOCContainer.querySelector(".toc-body") ||
      TOCContainer.querySelector(".toc-dropdown-body");
    var TOCContentExpanded = TOCContainer.querySelector("[dropdown-content]");
    var itemReference = template.content.querySelector("[data-toc-item]");

    var TOCStickyBody = d.querySelector("[data-sticky-toc-body]");

    allH2.forEach((h2, index) => {
      var item = itemReference.cloneNode(true);
      var itemLabel = item.querySelector("span");

      itemLabel.textContent = h2.textContent;

      item.addEventListener("click", () => scrollToElement(h2));

      if (TOCStickyBody) {
        var stickyItem = d.createElement("a");
        stickyItem.href = "#" + h2.id;
        stickyItem.classList.add("pill");

        stickyItem.innerHTML = `<span>${h2.textContent}</span>`;

        stickyItem.addEventListener("click", (e) => {
          e.preventDefault();
          history.replaceState(null, "", "#" + h2.id);
          scrollToElement(h2);
        });

        stickyButtons.push(stickyItem);

        TOCStickyBody.appendChild(stickyItem);
      }

      if (index >= H2Threshold) {
        TOCContentExpanded.appendChild(item);
        return;
      }

      TOCContentBody.appendChild(item);
    });

    placeholder.appendChild(TOCContainer);
  };
  renderTOC();

  var nav = document.querySelector("header-nav");
  var navRect;

  const navigationRect = () => {
    if (!navRect) {
      if (nav) {
        nav = nav;
        navRect = nav.getBoundingClientRect();
      }
    }

    if (nav) {
      var currentRect = nav.getBoundingClientRect();
      if (navRect.bottom !== currentRect.bottom) {
        navRect = currentRect;
      }
    }

    return navRect.bottom || 0;
  };

  let stickyButtonContainer = d.querySelector("[data-sticky-toc-body]");

  const setActiveStickyButton = (btn) => {
    if (!btn) {
      return;
    }
    if (btn.classList.contains("blogfilter-active")) {
      return;
    }

    if (!btn.classList.contains("blogfilter-active")) {
      let left = btn.offsetLeft;
      stickyButtonContainer.scrollTo({
        left: left,
        behavior: "smooth",
      });

      stickyButtons.forEach((btn) => btn.classList.remove("blogfilter-active"));
      btn.classList.add("blogfilter-active");
    }
  };

  const scrollCallback = () => {
    var scrollThreshold = navigationRect() + extraScrollSpacing;

    if (stickyBar) {
      stickyBar.classList.toggle("is-on", allH2[0].getBoundingClientRect().top <= scrollThreshold);
    }

    let closestChapter;
    let index;

    allH2.forEach((h2, idx) => {
      let rectTop = h2.getBoundingClientRect().top;

      if (scrollThreshold >= rectTop) {
        if (!closestChapter) {
          index = idx;
          closestChapter = {
            node: h2,
            top: rectTop,
          };
          return;
        }

        if (rectTop >= closestChapter.top) {
          index = idx;
          closestChapter = {
            node: h2,
            top: rectTop,
          };
        }
      }
    });

    setActiveStickyButton(stickyButtons[index]);
  };

  let throttleDelay = 100;
  const scrollThrottle = () => {
    let time = Date.now();

    return () => {
      if (time + throttleDelay - Date.now() <= 0) {
        scrollCallback();
        time = Date.now();
      }
    };
  };

  w.addEventListener("scroll", scrollThrottle());
  d.addEventListener("DOMContentLoaded", scrollCallback);

  const goToConclusion = () => {
    var scrollToTarget = allH2[allH2.length - 1];

    var matchSpellingTag = d.querySelector("[data-find-conclusion]");
    if (matchSpellingTag) {
      var matchSpelling = JSON.parse(
        matchSpellingTag.textContent
      )?.match_spelling;

      if (matchSpelling.includes("Translation missing")) {
        var matchSpelling = undefined;
      }

      if (matchSpelling) {
        var matchingH2 = Array.from(allH2).find(
          (h2) => h2.textContent.toLowerCase() === matchSpelling.toLowerCase()
        );

        if (matchingH2) {
          scrollToTarget = matchingH2;
        }
      }
    }
    var h2WithHTMLTag = Array.from(allH2).find((h2) =>
      h2.querySelector("span.data-conclusion")
    );
    if (h2WithHTMLTag) {
      h2WithHTMLTag.querySelector("span.data-conclusion").remove();
      scrollToTarget = h2WithHTMLTag;
    }
    var btn = d.querySelector("[data-article-conclusion-btn]");
    if (!btn) return;

    btn.addEventListener("click", () => {
      scrollToElement(scrollToTarget);
    });
  };

  const goToSolution = () => {
    var scrollToTarget = d.querySelector(".article-products-content");
    var btn = d.querySelector("[data-article-solution-btn]");
    if (!btn || !scrollToTarget) return;

    btn.addEventListener("click", () => {
      scrollToElement(scrollToTarget);
    });
  };

  goToConclusion();
  goToSolution();
})(document, window);

class QuizTeaser extends HTMLElement {
  constructor() {
    super();
  }

  loadContents() {
    this.reqURL =
      Shopify.routes.root + "pages/" + this.getAttribute("data-page");
    this.reqURL += "?sections=article-quiz-teaser";

    fetch(this.reqURL)
      .then((res) => res.json())
      .then((resJSON) => {
        var htmlContents = resJSON["article-quiz-teaser"];

        this.innerHTML = htmlContents;
      });
  }

  connectedCallback() {
    this.loadContents();
  }
}


customElements.define('quiz-teaser', QuizTeaser);
// Sources (ol.ec-sources): each item gets id "kilde-N", so a number in the text (<sup><a href="#kilde-N">N</a></sup>)
// jumps to it; the item is highlighted (:target) and links back (guides research, 2026-10-29).
(function () {
  document.querySelectorAll(".rte ol.ec-sources").forEach(function (list) {
    Array.prototype.forEach.call(list.children, function (li, i) {
      if (!li.id) li.id = "kilde-" + (i + 1);
    });
  });
})();

// Comparison tables (table.ec-compare): option count (--ec-cols), header scopes, the scroll box and its hint.
(function () {
  document.querySelectorAll(".rte table.ec-compare").forEach(function (table) {
    var head = table.querySelector("thead tr") || table.querySelector("tr");
    if (!head) return;
    var cols = Math.max(1, head.children.length - 1);
    table.style.setProperty("--ec-cols", String(cols));
    // Header scopes for screen readers, and a swipe hint on phones when the grid is wider than the screen.
    table.querySelectorAll("thead th").forEach(function (th) { th.setAttribute("scope", "col"); });
    table.querySelectorAll("tbody th").forEach(function (th) { th.setAttribute("scope", "row"); });
    // The table scrolls inside its own box (phones); a hint under it when it is wider than the screen.
    var wrap = table.parentElement;
    if (!wrap.classList.contains("ec-compare-scroll")) {
      wrap = document.createElement("div");
      wrap.className = "ec-compare-scroll";
      table.before(wrap);
      wrap.append(table);
    }
    var root = table.closest("[data-swipe-label]");
    var hint = null;
    if (root && root.dataset.swipeLabel) {
      hint = document.createElement("p");
      hint.className = "ec-compare-hint";
      hint.textContent = root.dataset.swipeLabel;
      wrap.after(hint);
    }
    var check = function () {
      var wide = wrap.scrollWidth > wrap.clientWidth + 2;
      if (hint) hint.hidden = !wide;
      if (wide) {
        wrap.tabIndex = 0;
        wrap.setAttribute("role", "region");
        wrap.setAttribute("aria-label", (table.querySelector("thead") || table).textContent.trim().replace(/\s+/g, ", "));
      } else {
        wrap.removeAttribute("tabindex");
        wrap.removeAttribute("role");
        wrap.removeAttribute("aria-label");
      }
    };
    check();
    window.addEventListener("resize", check);
  });
})();

// "Indhold" (component system v6, 2026-10-30): a ruled block right after the lede – the title and the number of sections,
// the first five sections as numbered links, "Vis alle N afsnit" for the rest. No box; nothing folded away by default.
(function () {
  var content = document.querySelector(".template-article-content");
  if (!content) return;
  var heads = Array.prototype.slice.call(content.querySelectorAll(".rte h2[id]"));
  if (heads.length < 3) return;
  var PREVIEW = 5;
  var label = content.dataset.tocLabel || "Indhold";
  var nav = document.createElement("nav");
  nav.className = "article-toc-box";
  nav.setAttribute("aria-label", label);
  var head = document.createElement("div");
  head.className = "article-toc-box__head";
  var title = document.createElement("p");
  title.className = "article-toc-box__title";
  title.textContent = label;
  var meta = document.createElement("span");
  meta.className = "article-toc-box__meta";
  meta.textContent = heads.length + " afsnit";
  head.append(title, meta);
  var list = document.createElement("ol");
  list.id = "article-toc-list";
  var folded = heads.length > PREVIEW + 1;
  heads.forEach(function (h, i) {
    var li = document.createElement("li"), a = document.createElement("a"), n = document.createElement("span"), t = document.createElement("span");
    n.className = "article-toc-box__n"; n.textContent = String(i + 1).padStart(2, "0");
    t.textContent = h.textContent.trim();
    a.href = "#" + h.id; a.append(n, t);
    li.append(a);
    if (folded && i >= PREVIEW) li.hidden = true;
    list.append(li);
  });
  nav.append(head, list);
  if (folded) {
    var more = document.createElement("button");
    more.type = "button";
    more.className = "article-toc-box__more";
    more.setAttribute("aria-controls", list.id);
    more.setAttribute("aria-expanded", "false");
    var txt = document.createElement("span");
    var showAll = "Vis alle " + heads.length + " afsnit", showLess = "Vis færre";
    txt.textContent = showAll;
    more.innerHTML = '<svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true"><use href="#icon-chevron"></use></svg>';
    more.prepend(txt);
    more.addEventListener("click", function () {
      var open = more.getAttribute("aria-expanded") !== "true";
      list.querySelectorAll("li").forEach(function (li, i) { if (i >= PREVIEW) li.hidden = !open; });
      more.setAttribute("aria-expanded", String(open));
      txt.textContent = open ? showLess : showAll;
      if (open) { var first = list.children[PREVIEW]; if (first) first.querySelector("a").focus({ preventScroll: true }); }
    });
    nav.append(more);
  }
  // After the lede (the first paragraph of the text), else at the start.
  var firstBox = content.querySelector(":scope > .rte");
  var lede = firstBox && firstBox.firstElementChild;
  if (lede && lede.tagName === "P") lede.after(nav);
  else content.prepend(nav);
})();

// The article's summary under the title: clamped to its first lines with "Læs mere" when it is longer (layout A).
(function () {
  var box = document.querySelector(".article-hero__standfirst");
  if (!box) return;
  box.querySelectorAll("[data-dropdown-trigger], .text-dropdown-trigger, button").forEach(function (b) { b.hidden = true; });
  box.classList.add("is-clamped");
  var inner = box.firstElementChild;
  // Short summaries (two or three sentences) are shown whole; only long old excerpts get "Læs mere".
  if (!inner || inner.textContent.trim().length < 260 || inner.scrollHeight <= inner.clientHeight + 2) {
    box.classList.remove("is-clamped");
    return;
  }
  var more = document.createElement("button");
  more.type = "button";
  more.className = "article-hero__more";
  more.textContent = box.dataset.more || "Læs mere";
  more.setAttribute("aria-expanded", "false");
  more.addEventListener("click", function () {
    var open = box.classList.toggle("is-clamped") === false;
    more.textContent = open ? (box.dataset.less || "Vis mindre") : (box.dataset.more || "Læs mere");
    more.setAttribute("aria-expanded", String(open));
  });
  box.after(more);
})();

// --- Guides design system: the interactive blocks, built from plain markup in the article's own text. ---
(function () {
  // The whole text: the routine card splits it into several .rte boxes (article-content-parser).
  var root = document.querySelector(".template-article-content");
  if (!root) return;
  var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  // The theme's one icon set (snippets/vector-icons.liquid): ticks, crosses and pluses always from the sprite.
  var icon = function (id, cls) { var w = el("span", cls); w.setAttribute("aria-hidden", "true"); w.innerHTML = '<svg viewBox="0 0 20 20" width="18" height="18"><use href="#' + id + '"></use></svg>'; return w; };

  // Doctor note: the sprite's plus in a beige badge (decoration; without script the note simply has no badge).
  root.querySelectorAll(".ec-callout--doctor").forEach(function (c) { if (!c.querySelector(".ec-callout__badge")) c.prepend(icon("icon-plus", "ec-callout__badge")); });

  // Tabs: <div class="ec-tabs"><section data-tab="Essens">…</section>…</div>
  root.querySelectorAll(".ec-tabs").forEach(function (box, n) {
    var panels = Array.prototype.slice.call(box.querySelectorAll(":scope > section[data-tab]"));
    if (panels.length < 2) return;
    var list = el("div", "ec-tabs__list"); list.setAttribute("role", "tablist");
    panels.forEach(function (p, i) {
      // The tab's name is the section's own <h3> (readable without script, for crawlers), else its data-tab.
      var h = p.querySelector(":scope > h3");
      var b = el("button", null, h ? h.textContent : p.dataset.tab); b.type = "button"; b.setAttribute("role", "tab");
      if (h) h.classList.add("ec-tabs__heading");
      b.id = "ec-tab-" + n + "-" + i; p.setAttribute("role", "tabpanel"); p.setAttribute("aria-labelledby", b.id);
      b.addEventListener("click", function () { show(i); });
      list.append(b);
    });
    function show(i) {
      list.querySelectorAll("button").forEach(function (b, j) { b.setAttribute("aria-selected", String(i === j)); b.tabIndex = i === j ? 0 : -1; });
      panels.forEach(function (p, j) { p.hidden = i !== j; });
    }
    // Keyboard: the arrows, Home and End move between the tabs (only the chosen tab is in the Tab order).
    list.addEventListener("keydown", function (e) {
      var tabs = Array.prototype.slice.call(list.querySelectorAll("button"));
      var i = tabs.indexOf(document.activeElement); if (i < 0) return;
      var to = e.key === "ArrowRight" ? (i + 1) % tabs.length : e.key === "ArrowLeft" ? (i - 1 + tabs.length) % tabs.length : e.key === "Home" ? 0 : e.key === "End" ? tabs.length - 1 : -1;
      if (to < 0) return;
      e.preventDefault(); show(to); tabs[to].focus();
    });
    box.prepend(list); show(0);
  });

  // Routine switch: <div class="ec-routine"><ol data-label="Morgen">…</ol><ol data-label="Aften">…</ol></div>
  root.querySelectorAll(".ec-routine").forEach(function (box) {
    var lists = Array.prototype.slice.call(box.querySelectorAll(":scope > ol[data-label]"));
    if (lists.length < 2) return;
    var sw = el("div", "ec-routine__switch");
    // The routine builder's own sun and moon (assets/routine-build.js), so both places look the same (owner 2026-10-29).
    var icons = {
      morgen: '<svg aria-hidden="true" viewBox="0 0 20 20" width="14" height="14"><circle cx="10" cy="10" r="3.6" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M10 2.5v2M10 15.5v2M2.5 10h2M15.5 10h2M4.7 4.7l1.4 1.4M13.9 13.9l1.4 1.4M4.7 15.3l1.4-1.4M13.9 6.1l1.4-1.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
      aften: '<svg aria-hidden="true" viewBox="0 0 20 20" width="14" height="14"><path d="M15.5 12.6A6.5 6.5 0 0 1 7.4 4.5a6.5 6.5 0 1 0 8.1 8.1z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>'
    };
    lists.forEach(function (l, i) {
      var b = el("button"); b.type = "button";
      b.innerHTML = icons[l.dataset.label.toLowerCase()] || "";
      b.append(document.createTextNode(l.dataset.label));
      b.addEventListener("click", function () { pick(i); }); sw.append(b);
    });
    function pick(i) { sw.querySelectorAll("button").forEach(function (b, j) { b.setAttribute("aria-pressed", String(i === j)); }); lists.forEach(function (l, j) { l.hidden = i !== j; }); }
    box.prepend(sw); box.classList.add("is-switchable"); pick(0);
  });

  // Myth or fact: <div class="ec-myth" data-answer="myte|fakta"><q>…</q><p>…</p></div>
  root.querySelectorAll(".ec-myth").forEach(function (m) {
    var p = m.querySelector("p"); if (!p) return;
    var answer = (m.dataset.answer || "myte").toLowerCase();
    p.hidden = true;
    var row = el("div", "ec-myth__answers");
    ["Myte", "Fakta"].forEach(function (label) {
      var b = el("button", null, label); b.type = "button";
      b.addEventListener("click", function () {
        m.classList.add("is-answered");
        // The verdict is in the text itself (<b>Myte.</b> …, readable without script); here only right or not.
        var right = label.toLowerCase() === answer;
        p.prepend(el("span", "ec-myth__verdict " + (right ? "is-right" : "is-wrong"), right ? "Rigtigt" : "Ikke helt"));
        p.hidden = false;
      });
      row.append(b);
    });
    p.before(row);
  });

  // Quiz: <div class="ec-quiz" data-title><div class="ec-q"><h4/><ul><li data-correct/>…</ul><p/></div>…</div>
  // A beige band with the title, "1 af 3" and one step per question; lettered answers (CSS); one question at a time.
  root.querySelectorAll(".ec-quiz").forEach(function (quiz) {
    var qs = Array.prototype.slice.call(quiz.querySelectorAll(":scope > .ec-q"));
    if (!qs.length) return;
    var band = el("div", "ec-quiz__band");
    var head = el("div", "ec-quiz__head"); var title = el("span", null, quiz.dataset.title || "Test din viden"); var count = el("span");
    head.append(title, count);
    var steps = el("div", "ec-quiz__steps"); steps.setAttribute("aria-hidden", "true");
    qs.forEach(function () { steps.append(el("i")); });
    band.append(head, steps);
    quiz.prepend(band);
    var right = 0;
    function show(i) {
      qs.forEach(function (q, j) { q.hidden = i !== j; });
      count.textContent = (i + 1) + " af " + qs.length;
      steps.querySelectorAll("i").forEach(function (s, j) { s.classList.toggle("is-done", j <= i); });
    }
    qs.forEach(function (q, i) {
      var why = q.querySelector(":scope > p"); if (why) why.hidden = true;
      var answered = false;
      q.querySelectorAll("li").forEach(function (li) {
        li.tabIndex = 0; li.setAttribute("role", "button");
        var go = function () {
          if (answered) return; answered = true;
          q.classList.add("is-answered");
          li.classList.add("is-picked");
          if (li.hasAttribute("data-correct")) right++;
          q.querySelectorAll("li").forEach(function (x) {
            var ok = x.hasAttribute("data-correct");
            x.classList.add(ok ? "is-right" : "is-wrong");
            if (ok || x === li) { x.classList.add("has-mark"); x.prepend(icon(ok ? "icon-checkmark" : "icon-close", "ec-quiz__mark")); }
            x.removeAttribute("tabindex"); x.setAttribute("aria-disabled", "true");
          });
          if (why) why.hidden = false;
          var last = i === qs.length - 1;
          var next = el("button", "ec-quiz__next", last ? "Se dit resultat" : "Næste spørgsmål"); next.type = "button";
          next.addEventListener("click", function () {
            next.remove();
            if (!last) { show(i + 1); var h = qs[i + 1].querySelector("li"); if (h) h.focus({ preventScroll: true }); return; }
            qs.forEach(function (x) { x.hidden = true; });
            var res = el("div", "ec-quiz__result"); res.setAttribute("role", "status");
            res.append(el("h4", null, "Du fik " + right + " af " + qs.length + " rigtige"));
            res.append(el("p", null, right === qs.length ? "Flot. Du kender det vigtigste." : "Du finder også svarene i denne artikel."));
            quiz.append(res);
            count.textContent = "Færdig";
          });
          q.append(next);
          next.focus({ preventScroll: true });
        };
        li.addEventListener("click", go);
        li.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); go(); } });
      });
    });
    show(0);
  });
})();

// A citation ([1]) opens the folded "Kilder" under the FAQ and jumps to its source.
(function () {
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#kilde-"]');
    if (!a) return;
    var box = document.querySelector(".article-sources");
    if (box) box.open = true;
    // Land the source below the header and the contents bar, and move focus there (keyboard and screen readers).
    var li = document.getElementById(a.getAttribute("href").slice(1));
    if (!li) return;
    e.preventDefault();
    history.replaceState(null, "", a.getAttribute("href"));
    li.tabIndex = -1;
    li.scrollIntoView({ block: "center" });
    li.focus({ preventScroll: true });
    li.classList.add("is-cited");
    setTimeout(function () { li.classList.remove("is-cited"); }, 2500);
  });
})();
